module.exports = __webpack_public_path__ + "static/media/8.85a8df5c.gif";